
    $(function(){
        $.get('https://freegeoip.net/json/', function(data)
        {
            // Get the country code and name
            var countryCode = data.country_code.toLowerCase();
            var countryName = data.country_name;
            
            // If "United States", fix grammar to make it "the United States"
            if (countryName == 'United States')
                countryName = 'The United States';
            
            // Now, update the interface
            $('#flagIcon').addClass(countryCode);
            $('#countryName').text(countryName);
        }, 'jsonp');
    });

    $(function(){
        $.get('https://freegeoip.net/json/', function(data)
        {
            // Get the country code and name
            var countryCode = data.country_code.toLowerCase();
            var countryName = data.country_name;
            
            // If "United States", fix grammar to make it "the United States"
            if (countryName == 'United States')
                countryName = 'The United States';
            
            // Now, update the interface
            $('#flagIcon2').addClass(countryCode);
            $('#countryName2').text(countryName);
        }, 'jsonp');
    });

    $(function(){
        $.get('https://freegeoip.net/json/', function(data)
        {
            // Get the country code and name
            var countryCode = data.country_code.toLowerCase();
            var countryName = data.country_name;
            
            // If "United States", fix grammar to make it "the United States"
            if (countryName == 'United States')
                countryName = 'The United States';
            
            // Now, update the interface
            $('#flagIcon3').addClass(countryCode);
            $('#countryName3').text(countryName);
        }, 'jsonp');
    });

